import React from 'react';

const SchemaInterventionalCardiology = () => {
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "What is interventional cardiology?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Interventional cardiology is a specialized branch of cardiology that diagnoses and treats heart and blood vessel diseases using catheter-based, minimally invasive procedures instead of open-heart surgery. At HDNA Aarogyam Hospital, these procedures are performed in a state-of-the-art catheterization laboratory."
                }
            },
            {
                "@type": "Question",
                "name": "What conditions can be treated with interventional cardiology?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Interventional cardiology can treat several cardiovascular conditions, including: Coronary artery disease (blocked heart arteries), Heart attacks (acute myocardial infarction), Peripheral vascular disease, Structural heart defects such as ASD and VSD, Valve disorders like aortic stenosis, Blocked arteries in limbs and organs."
                }
            },
            {
                "@type": "Question",
                "name": "What is coronary angioplasty and stenting (PCI)?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Coronary angioplasty, also called Percutaneous Coronary Intervention (PCI), is a minimally invasive procedure used to open blocked coronary arteries. A small balloon and stent are inserted through a catheter to restore normal blood flow to the heart."
                }
            },
            {
                "@type": "Question",
                "name": "When should I see an interventional cardiologist?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You should consult an interventional cardiologist if you experience: Chest pain or pressure, Shortness of breath, Fatigue or swelling in the legs, History of heart attack or blocked arteries, Abnormal ECG or echocardiography results, Congenital heart defects. Early evaluation can help prevent serious cardiac complications."
                }
            },
            {
                "@type": "Question",
                "name": "What is the recovery time after a coronary intervention?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Most patients are discharged within 1–2 days after the procedure and can resume normal daily activities within about one week, depending on the doctor’s advice."
                }
            },
            {
                "@type": "Question",
                "name": "Is interventional cardiology safe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes. Interventional cardiology procedures are minimally invasive and generally very safe when performed by experienced specialists using advanced imaging and modern technology."
                }
            },
            {
                "@type": "Question",
                "name": "How long does a stent last?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Modern drug-eluting stents are designed to remain effective for many years. Long-term success depends on following prescribed medications, maintaining a healthy lifestyle, and regular follow-up with your cardiologist."
                }
            },
            {
                "@type": "Question",
                "name": "Is PCI safe for older patients?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, PCI can be safely performed in elderly patients, but the treatment plan depends on the patient’s overall health condition and evaluation by an interventional cardiologist."
                }
            },
            {
                "@type": "Question",
                "name": "Do interventional cardiology procedures require open-heart surgery?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No. Most procedures are performed through small vascular access points in the wrist or groin, using catheters and imaging guidance, eliminating the need for major surgery in many cases."
                }
            },
            {
                "@type": "Question",
                "name": "Who performs interventional cardiology procedures at HDNA Aarogyam Hospital?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Interventional procedures at HDNA Aarogyam Hospital are performed by experienced specialists including Dr. Nishant Tripathy and Dr. Ashok Kumar, along with a skilled cardiac care team."
                }
            }
        ]
    };

    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
            />
        </>
    );
};

export default SchemaInterventionalCardiology;